var _defs, _g, _circle;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFusionMark(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "30.5 135.5 83 83",
    width: 83,
    height: 83,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "round"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 72,
    cy: 177,
    r: 33.5
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#round)"
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("g", null), /*#__PURE__*/React.createElement("clipPath", {
    id: "69911752f2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 31.285156 143.148438 L 113.53125 143.148438 L 113.53125 211.285156 L 31.285156 211.285156 Z M 31.285156 143.148438 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "cf83831605"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 72.335938 143.148438 C 49.664062 143.148438 31.285156 158.402344 31.285156 177.214844 C 31.285156 196.03125 49.664062 211.285156 72.335938 211.285156 C 95.007812 211.285156 113.382812 196.03125 113.382812 177.214844 C 113.382812 158.402344 95.007812 143.148438 72.335938 143.148438 Z M 72.335938 143.148438 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "f3f3c83d66"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 54.960938 148.003906 L 113.382812 148.003906 L 113.382812 206.429688 L 54.960938 206.429688 Z M 54.960938 148.003906 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "2c94a835d1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 84.171875 148.003906 C 68.039062 148.003906 54.960938 161.082031 54.960938 177.214844 C 54.960938 193.351562 68.039062 206.429688 84.171875 206.429688 C 100.304688 206.429688 113.382812 193.351562 113.382812 177.214844 C 113.382812 161.082031 100.304688 148.003906 84.171875 148.003906 Z M 84.171875 148.003906 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "3b476f7960"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 52 148 L 82 148 L 82 188 L 52 188 Z M 52 148 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "a08e2eb8c0"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 52.804688 149.121094 L 79.8125 148.1875 L 81.125 186.144531 L 54.117188 187.074219 Z M 52.804688 149.121094 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "b4e56eb76c"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 79 144 L 90 144 L 90 152 L 79 152 Z M 79 144 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "9586074d10"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 79.351562 148.433594 L 80.78125 144.472656 L 89.148438 147.496094 L 87.714844 151.460938 Z M 79.351562 148.433594 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "714c5efc4a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 76 146 L 104 146 L 104 167 L 76 167 Z M 76 146 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "7dbfe1d986"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 81.488281 142.207031 L 106.640625 154.328125 L 98.582031 171.050781 L 73.429688 158.929688 Z M 81.488281 142.207031 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "ba47d51123"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 94.050781 148.257812 C 87.113281 144.914062 79.683594 145.949219 77.457031 150.566406 C 75.230469 155.1875 79.054688 161.640625 85.992188 164.984375 C 92.929688 168.328125 100.359375 167.296875 102.585938 162.675781 C 104.8125 158.058594 100.992188 151.601562 94.050781 148.257812 Z M 94.050781 148.257812 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "ec93955858"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 75 190 L 108 190 L 108 207 L 75 207 Z M 75 190 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "1d83cc40b3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 73.429688 197.832031 L 105.148438 187.066406 L 109.132812 198.804688 L 77.414062 209.566406 Z M 73.429688 197.832031 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "d540e6e0cb"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 89.28125 192.453125 C 80.527344 195.425781 74.320312 200.460938 75.421875 203.699219 C 76.519531 206.941406 84.507812 207.160156 93.261719 204.1875 C 102.015625 201.21875 108.222656 196.183594 107.121094 192.941406 C 106.023438 189.703125 98.035156 189.484375 89.28125 192.453125 Z M 89.28125 192.453125 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "8b5e5d6a3e"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 75 193 L 101 193 L 101 211 L 75 211 Z M 75 193 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "1117cb48d3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 73.429688 204.59375 L 96.855469 190.015625 L 102.65625 199.34375 L 79.234375 213.917969 Z M 73.429688 204.59375 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "979389f856"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 85.125 197.3125 C 78.667969 201.332031 74.730469 206.679688 76.332031 209.253906 C 77.933594 211.832031 84.46875 210.660156 90.929688 206.640625 C 97.390625 202.621094 101.328125 197.277344 99.722656 194.699219 C 98.121094 192.125 91.585938 193.296875 85.125 197.3125 Z M 85.125 197.3125 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "74a062501b"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 77 194 L 103 194 L 103 210 L 77 210 Z M 77 194 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "211638edb9"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 75.09375 202.589844 L 100.070312 190.863281 L 104.992188 201.347656 L 80.015625 213.074219 Z M 75.09375 202.589844 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "c4b9a392f9"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 87.5625 196.738281 C 80.675781 199.96875 76.195312 204.9375 77.554688 207.832031 C 78.914062 210.726562 85.597656 210.453125 92.484375 207.21875 C 99.371094 203.984375 103.851562 199.019531 102.492188 196.125 C 101.132812 193.230469 94.449219 193.503906 87.5625 196.738281 Z M 87.5625 196.738281 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "c58e894d05"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 93 192 L 108 192 L 108 205 L 93 205 Z M 93 192 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "13c07895ab"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 92.125 202.816406 L 106.058594 190.996094 L 109.117188 194.601562 L 95.183594 206.425781 Z M 92.125 202.816406 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "1160deeca3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 99.089844 196.910156 C 95.242188 200.171875 92.808594 203.625 93.652344 204.621094 C 94.5 205.617188 98.300781 203.777344 102.148438 200.515625 C 105.996094 197.253906 108.429688 193.800781 107.582031 192.804688 C 106.738281 191.808594 102.933594 193.644531 99.089844 196.910156 Z M 99.089844 196.910156 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "52b3c2d565"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 77 144 L 95 144 L 95 152 L 77 152 Z M 77 144 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "766ccaba45"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 77.65625 143.148438 L 95.292969 147.953125 L 94.070312 152.441406 L 76.433594 147.636719 Z M 77.65625 143.148438 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "dfa92327cd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 86.46875 145.550781 C 81.601562 144.222656 77.382812 144.152344 77.046875 145.394531 C 76.707031 146.632812 80.378906 148.710938 85.246094 150.039062 C 90.113281 151.363281 94.332031 151.433594 94.671875 150.195312 C 95.007812 148.957031 91.335938 146.875 86.46875 145.550781 Z M 86.46875 145.550781 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "decd601783"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 90 147 L 106 147 L 106 160 L 90 160 Z M 90 147 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "0dcd048dd4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 92.023438 145.894531 L 106.617188 156.890625 L 103.773438 160.667969 L 89.175781 149.671875 Z M 92.023438 145.894531 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "ba68217d94"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 99.316406 151.390625 C 95.289062 148.355469 91.382812 146.742188 90.597656 147.785156 C 89.8125 148.828125 92.441406 152.132812 96.472656 155.167969 C 100.5 158.203125 104.40625 159.816406 105.191406 158.773438 C 105.976562 157.730469 103.347656 154.425781 99.316406 151.390625 Z M 99.316406 151.390625 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "de70ea10f8"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 68 143 L 95 143 L 95 154 L 68 154 Z M 68 143 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "3f616d2f8c"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 69.183594 141.558594 L 95.3125 146.375 L 93.757812 154.820312 L 67.625 150.003906 Z M 69.183594 141.558594 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "624936d745"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 82.234375 143.964844 C 75.023438 142.636719 68.835938 143.449219 68.402344 145.78125 C 67.972656 148.113281 73.46875 151.082031 80.675781 152.410156 C 87.882812 153.738281 94.074219 152.925781 94.503906 150.59375 C 94.933594 148.261719 89.441406 145.292969 82.234375 143.964844 Z M 82.234375 143.964844 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "c27c1f8005"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 64.285156 144.066406 L 76.4375 144.066406 L 76.4375 152.304688 L 64.285156 152.304688 Z M 64.285156 144.066406 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "e30ecea626"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 70.011719 143.148438 L 76.4375 143.148438 L 76.4375 146.898438 L 70.011719 146.898438 Z M 70.011719 143.148438 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "25c8df9ad2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 86.433594 145.910156 L 110.757812 145.910156 L 110.757812 168.042969 L 86.433594 168.042969 Z M 86.433594 145.910156 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "50210b979e"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 86.476562 149.625 C 87.824219 146.101562 89.101562 145.875 89.925781 145.949219 C 90.75 145.949219 91.574219 146.398438 92.324219 146.699219 C 93.148438 147.074219 93.976562 147.523438 94.800781 148.050781 C 95.625 148.574219 96.375 149.398438 97.273438 149.925781 C 98.175781 150.375 99.226562 150.675781 100.050781 151.199219 C 100.800781 151.648438 101.398438 152.175781 102.074219 152.699219 C 102.675781 153.226562 103.5 153.824219 103.875 154.351562 C 104.175781 154.726562 104.25 155.175781 104.476562 155.476562 C 104.773438 155.851562 105.148438 156 105.523438 156.375 C 105.976562 156.824219 106.574219 157.5 107.101562 158.101562 C 107.625 158.773438 108.074219 159.523438 108.523438 160.199219 C 108.976562 160.875 109.5 161.398438 109.800781 162.148438 C 110.25 162.898438 110.925781 163.875 110.699219 164.773438 C 110.476562 165.898438 108.300781 167.851562 107.25 168 C 106.5 168.074219 105.824219 167.324219 105.148438 166.949219 C 104.476562 166.574219 103.726562 166.125 103.050781 165.601562 C 102.300781 165.074219 101.625 164.25 100.875 163.648438 C 100.273438 163.050781 99.675781 162.375 99 161.851562 C 98.324219 161.398438 97.574219 161.101562 96.976562 160.574219 C 96.375 160.125 95.851562 159.523438 95.25 159 C 94.574219 158.398438 93.824219 157.800781 93.148438 157.199219 C 92.550781 156.675781 91.949219 156.148438 91.425781 155.550781 C 90.824219 155.023438 90.300781 154.425781 89.699219 153.898438 C 89.101562 153.226562 88.273438 152.699219 87.75 152.023438 C 87.226562 151.273438 86.476562 149.625 86.476562 149.625 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "6fef4dac82"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 109.679688 163.945312 L 113.785156 163.945312 L 113.785156 175.378906 L 109.679688 175.378906 Z M 109.679688 163.945312 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "5dc5eb3355"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 110.398438 163.949219 C 113.625 170.699219 114.148438 174.898438 113.550781 175.273438 C 113.101562 175.5 111.074219 173.625 111.074219 173.25 C 111.074219 173.101562 111.449219 172.875 111.675781 172.949219 C 112.125 173.023438 113.625 174.523438 113.550781 174.898438 C 113.550781 175.125 113.101562 175.425781 112.949219 175.351562 C 112.425781 175.125 112.875 170.773438 112.273438 168.824219 C 111.75 167.175781 109.574219 165 109.726562 164.324219 C 109.800781 164.101562 110.398438 163.949219 110.398438 163.949219 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bed26f5186"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 105.269531 163.09375 L 114 163.09375 L 114 191.601562 L 105.269531 191.601562 Z M 105.269531 163.09375 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "6c666b89cd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 110.699219 164.625 C 112.949219 169.574219 114 174.148438 113.925781 175.875 C 113.925781 176.625 113.773438 177.074219 113.476562 177.523438 C 113.101562 177.976562 112.574219 178.425781 111.976562 178.5 C 111.300781 178.648438 110.398438 178.425781 109.726562 177.898438 C 108.824219 177.226562 108 175.574219 107.625 174.226562 C 107.25 172.875 107.925781 171.074219 107.699219 169.648438 C 107.398438 168.300781 106.199219 166.875 106.125 165.824219 C 106.125 165.148438 106.351562 164.550781 106.726562 164.023438 C 107.101562 163.574219 107.773438 163.199219 108.300781 163.125 C 108.898438 163.050781 109.648438 163.199219 110.175781 163.5 C 110.625 163.800781 110.925781 164.25 111.300781 165 C 112.050781 166.5 113.25 169.726562 113.625 172.425781 C 114.074219 175.5 113.925781 179.398438 113.25 182.550781 C 112.648438 185.550781 111.449219 189.601562 109.949219 190.875 C 109.050781 191.550781 107.625 191.699219 106.875 191.398438 C 106.125 191.101562 105.375 190.125 105.300781 189.375 C 105.226562 188.476562 106.574219 187.800781 107.023438 186.523438 C 107.773438 184.351562 107.398438 178.648438 108.449219 177 C 108.976562 176.175781 109.800781 175.875 110.476562 175.648438 C 111.148438 175.574219 111.898438 175.648438 112.425781 175.949219 C 112.949219 176.175781 113.476562 176.851562 113.699219 177.375 C 113.925781 177.898438 114 178.648438 113.773438 179.25 C 113.476562 179.925781 112.648438 180.824219 111.898438 180.976562 C 111.148438 181.199219 109.949219 180.898438 109.351562 180.449219 C 108.824219 179.925781 108.375 178.800781 108.449219 178.050781 C 108.523438 177.300781 109.199219 176.25 109.875 175.949219 C 110.550781 175.574219 111.75 175.574219 112.425781 175.949219 C 113.101562 176.25 113.773438 177.300781 113.851562 178.050781 C 113.925781 178.800781 113.476562 179.925781 112.949219 180.449219 C 112.351562 180.898438 111.148438 181.199219 110.398438 180.976562 C 109.648438 180.824219 108.75 180 108.523438 179.25 C 108.300781 178.425781 108.75 176.851562 109.351562 176.324219 C 109.875 175.726562 111.074219 175.5 111.824219 175.648438 C 112.574219 175.875 113.324219 176.476562 113.699219 177.375 C 114.300781 178.875 113.851562 182.324219 113.175781 184.574219 C 112.574219 186.824219 111.148438 189.824219 109.949219 190.875 C 109.125 191.476562 108.226562 191.699219 107.476562 191.550781 C 106.875 191.476562 106.199219 191.101562 105.824219 190.574219 C 105.449219 189.976562 105.226562 189.148438 105.300781 188.175781 C 105.449219 186.300781 107.773438 183.148438 108.300781 180.601562 C 108.824219 178.273438 108.976562 175.648438 108.675781 173.550781 C 108.375 171.824219 107.175781 170.550781 106.800781 168.976562 C 106.5 167.550781 105.898438 165.601562 106.351562 164.625 C 106.800781 163.800781 108.148438 163.050781 108.976562 163.125 C 109.648438 163.125 110.476562 163.648438 111 164.398438 C 111.898438 165.601562 112.648438 168.75 112.800781 170.324219 C 112.875 171.375 112.351562 172.050781 112.5 172.949219 C 112.648438 174.074219 114.074219 175.5 113.925781 176.476562 C 113.773438 177.300781 112.648438 178.273438 111.976562 178.5 C 111.449219 178.726562 110.699219 178.574219 110.175781 178.273438 C 109.726562 178.050781 109.273438 177.523438 109.050781 176.925781 C 108.675781 176.023438 109.050781 174.601562 108.824219 173.175781 C 108.449219 171.074219 106.273438 167.550781 106.648438 165.898438 C 106.800781 164.925781 107.550781 164.101562 108.226562 163.875 C 108.898438 163.648438 110.699219 164.625 110.699219 164.625 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "fcb0ce4da9"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 76.679688 142.53125 L 81.707031 142.53125 L 81.707031 144.480469 L 76.679688 144.480469 Z M 76.679688 142.53125 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "25135131f4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 76.875 143.175781 C 81 143.851562 81.074219 144.226562 80.925781 144.300781 C 80.550781 144.601562 77.773438 143.699219 77.550781 143.25 C 77.476562 143.023438 77.625 142.726562 77.851562 142.574219 C 78.375 142.351562 81.449219 143.101562 81.675781 143.550781 C 81.75 143.699219 81.300781 144.226562 81.300781 144.226562 C 81.300781 144.226562 81.601562 143.476562 81.601562 143.550781 C 81.675781 143.550781 81.75 144.074219 81.601562 144.226562 C 81.226562 144.523438 78.824219 143.925781 78.148438 143.625 C 77.773438 143.398438 77.398438 143.101562 77.398438 142.949219 C 77.476562 142.800781 77.851562 142.648438 78.226562 142.648438 C 78.824219 142.648438 80.625 143.25 80.925781 143.699219 C 81.074219 143.851562 81.074219 144.226562 80.925781 144.300781 C 80.476562 144.675781 77.023438 144.375 76.726562 143.925781 C 76.574219 143.699219 76.875 143.175781 76.875 143.175781 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "7fdc9c65db"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 76.140625 142.699219 L 80.507812 142.699219 L 80.507812 144.882812 L 76.140625 144.882812 Z M 76.140625 142.699219 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "1da3929e07"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 76.425781 142.726562 C 80.773438 144.523438 80.398438 144.824219 80.324219 144.824219 C 80.25 144.824219 80.476562 144.074219 80.476562 144.074219 C 80.476562 144.074219 80.550781 144.675781 80.398438 144.824219 C 79.875 145.125 76.425781 144 76.199219 143.398438 C 76.050781 143.175781 76.425781 142.726562 76.425781 142.726562 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "d53a8aaa83"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 67.246094 143.773438 L 79.351562 143.773438 L 79.351562 157.796875 L 67.246094 157.796875 Z M 67.246094 143.773438 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "7d05426d93"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 45.570312 142.203125 L 98 142.203125 L 98 212 L 45.570312 212 Z M 45.570312 142.203125 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "c2b5137195"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 31.101562 142.207031 L 115.101562 142.207031 L 115.101562 211.953125 L 31.101562 211.953125 Z M 31.101562 142.207031 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "5795974da6"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 73.195312 142.207031 C 49.949219 142.207031 31.101562 157.878906 31.101562 177.214844 C 31.101562 196.546875 49.949219 212.222656 73.195312 212.222656 C 96.441406 212.222656 115.289062 196.546875 115.289062 177.214844 C 115.289062 157.878906 96.441406 142.207031 73.195312 142.207031 Z M 73.195312 142.207031 ",
    clipRule: "nonzero"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#69911752f2)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cf83831605)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1d518c",
    d: "M 31.285156 143.148438 L 113.261719 143.148438 L 113.261719 211.285156 L 31.285156 211.285156 Z M 31.285156 143.148438 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#f3f3c83d66)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#2c94a835d1)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#d13138",
    d: "M 54.960938 148.003906 L 113.382812 148.003906 L 113.382812 206.429688 L 54.960938 206.429688 Z M 54.960938 148.003906 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#3b476f7960)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a08e2eb8c0)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1d518c",
    d: "M 52.804688 149.121094 L 79.8125 148.1875 L 81.125 186.164062 L 54.117188 187.09375 Z M 52.804688 149.121094 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#b4e56eb76c)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#9586074d10)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#d13138",
    d: "M 79.351562 148.433594 L 80.78125 144.472656 L 89.152344 147.5 L 87.722656 151.460938 Z M 79.351562 148.433594 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#714c5efc4a)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#7dbfe1d986)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ba47d51123)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#d13138",
    d: "M 81.488281 142.207031 L 106.640625 154.328125 L 98.582031 171.050781 L 73.429688 158.929688 Z M 81.488281 142.207031 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ec93955858)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#1d83cc40b3)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#d540e6e0cb)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#d13138",
    d: "M 73.429688 197.832031 L 105.148438 187.066406 L 109.132812 198.804688 L 77.414062 209.566406 Z M 73.429688 197.832031 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#8b5e5d6a3e)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#1117cb48d3)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#979389f856)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#d13138",
    d: "M 73.429688 204.59375 L 96.820312 190.039062 L 102.621094 199.367188 L 79.234375 213.917969 Z M 73.429688 204.59375 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#74a062501b)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#211638edb9)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#c4b9a392f9)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#d13138",
    d: "M 75.09375 202.589844 L 100.03125 190.882812 L 104.949219 201.367188 L 80.015625 213.074219 Z M 75.09375 202.589844 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#c58e894d05)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#13c07895ab)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#1160deeca3)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#d13138",
    d: "M 92.125 202.816406 L 106.058594 190.996094 L 109.117188 194.601562 L 95.183594 206.425781 Z M 92.125 202.816406 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#52b3c2d565)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#766ccaba45)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#dfa92327cd)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#d13138",
    d: "M 77.65625 143.148438 L 95.277344 147.949219 L 94.054688 152.4375 L 76.433594 147.636719 Z M 77.65625 143.148438 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#decd601783)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#0dcd048dd4)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ba68217d94)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#d13138",
    d: "M 92.023438 145.894531 L 106.617188 156.890625 L 103.773438 160.667969 L 89.175781 149.671875 Z M 92.023438 145.894531 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#de70ea10f8)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#3f616d2f8c)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#624936d745)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#d13138",
    d: "M 69.183594 141.558594 L 95.28125 146.367188 L 93.722656 154.816406 L 67.625 150.003906 Z M 69.183594 141.558594 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#c27c1f8005)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1d518c",
    d: "M 64.285156 144.066406 L 76.445312 144.066406 L 76.445312 152.304688 L 64.285156 152.304688 Z M 64.285156 144.066406 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#e30ecea626)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1d518c",
    d: "M 70.011719 143.148438 L 76.441406 143.148438 L 76.441406 146.898438 L 70.011719 146.898438 Z M 70.011719 143.148438 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#25c8df9ad2)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#50210b979e)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#d13138",
    d: "M 83.476562 142.949219 L 113.824219 142.949219 L 113.824219 171 L 83.476562 171 Z M 83.476562 142.949219 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#6fef4dac82)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#5dc5eb3355)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#d13138",
    d: "M 106.726562 160.949219 L 116.550781 160.949219 L 116.550781 178.335938 L 106.726562 178.335938 Z M 106.726562 160.949219 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#bed26f5186)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#6c666b89cd)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#d13138",
    d: "M 102.300781 160.125 L 116.925781 160.125 L 116.925781 194.628906 L 102.300781 194.628906 Z M 102.300781 160.125 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#fcb0ce4da9)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#25135131f4)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#d13138",
    d: "M 73.726562 139.574219 L 84.664062 139.574219 L 84.664062 147.375 L 73.726562 147.375 Z M 73.726562 139.574219 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#7fdc9c65db)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#1da3929e07)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#d13138",
    d: "M 73.199219 139.726562 L 83.863281 139.726562 L 83.863281 147.824219 L 73.199219 147.824219 Z M 73.199219 139.726562 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#d53a8aaa83)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1d518c",
    d: "M 67.246094 143.773438 L 79.351562 143.773438 L 79.351562 157.816406 L 67.246094 157.816406 Z M 67.246094 143.773438 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#7d05426d93)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ebebeb",
    d: "M 72.261719 211.664062 C 65.027344 211.664062 47.152344 210.535156 45.570312 189.949219 C 45.570312 189.949219 50.199219 198.152344 50.207031 197.1875 C 50.230469 194.058594 45.570312 182.597656 57.21875 174.792969 C 71.472656 165.246094 67.171875 153.53125 63.777344 153.304688 C 63.777344 153.304688 72.902344 152.382812 73.730469 164.480469 C 74.183594 171.0625 79.726562 152.0625 76.445312 141.542969 C 76.445312 141.542969 93.101562 150.363281 91.035156 172.078125 C 91.035156 172.078125 93.609375 167.160156 97.933594 169.789062 C 97.933594 169.789062 95.21875 170.722656 96.125 177.960938 C 97.03125 185.199219 100.988281 211.664062 72.261719 211.664062 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#d13138",
    d: "M 70.113281 210.914062 C 65.4375 210.699219 56.539062 209.671875 56.539062 198.019531 C 56.539062 186.371094 68.191406 184.789062 68.191406 174.042969 C 68.191406 174.042969 73.730469 175.964844 73.167969 181.28125 C 73.167969 181.28125 84.023438 174.496094 83.117188 166.464844 C 83.117188 166.464844 106.605469 212.582031 70.113281 210.914062 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#d13138",
    d: "M 70.113281 210.914062 C 65.4375 210.699219 56.539062 209.671875 56.539062 198.019531 C 56.539062 186.371094 68.191406 184.789062 68.191406 174.042969 C 68.191406 174.042969 73.730469 175.964844 73.167969 181.28125 C 73.167969 181.28125 84.023438 174.496094 83.117188 166.464844 C 83.117188 166.464844 106.605469 212.582031 70.113281 210.914062 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ebebeb",
    d: "M 72.375 190.847656 C 72.375 190.847656 75.203125 199.140625 70.566406 199.140625 C 67.339844 199.140625 67.738281 195.632812 67.738281 195.632812 C 67.738281 195.632812 58.746094 210.222656 72.375 210.222656 C 75.136719 210.222656 79.953125 209.65625 79.953125 202.191406 C 79.953125 194.730469 75.765625 191.71875 72.375 190.847656 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#c2b5137195)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#5795974da6)"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0.75, 0, 0, 0.75, 31.101342, 142.206744)",
    fill: "none",
    strokeLinejoin: "miter",
    d: "M 56.125295 0.000382651 C 25.130503 0.000382651 0.000294563 20.896216 0.000294563 46.677466 C 0.000294563 72.453508 25.130503 93.354549 56.125295 93.354549 C 87.120086 93.354549 112.250295 72.453508 112.250295 46.677466 C 112.250295 20.896216 87.120086 0.000382651 56.125295 0.000382651 Z M 56.125295 0.000382651 ",
    stroke: "#ffffff",
    strokeWidth: 4,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  }))), /*#__PURE__*/React.createElement("g", {
    fill: "#1d518c",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(118.524738, 194.406889)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 15.3125 0 L 15.3125 -15.125 L 33.0625 -15.125 L 33.0625 -25.171875 L 15.3125 -25.171875 L 15.3125 -29.84375 L 33.484375 -29.84375 L 33.484375 -39.890625 L 3.234375 -39.890625 L 3.234375 0 Z M 15.3125 0 "
  })))), /*#__PURE__*/React.createElement("g", {
    fill: "#1d518c",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(153.923033, 194.406889)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 3.234375 -16.390625 C 3.234375 -6.515625 8.96875 0.71875 22.421875 0.71875 C 35.875 0.71875 41.5625 -6.515625 41.5625 -16.4375 L 41.5625 -39.890625 L 29.296875 -39.890625 L 29.296875 -16.796875 C 29.296875 -12.96875 27.328125 -9.921875 22.421875 -9.921875 C 17.453125 -9.921875 15.484375 -12.96875 15.484375 -16.796875 L 15.484375 -39.890625 L 3.234375 -39.890625 Z M 3.234375 -16.390625 "
  })))), /*#__PURE__*/React.createElement("g", {
    fill: "#1d518c",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(198.709037, 194.406889)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 0.171875 -5.625 C 4.421875 -1.796875 10.21875 0.71875 18.71875 0.71875 C 29.421875 0.71875 35.9375 -4.359375 35.9375 -13.15625 C 35.9375 -22.359375 26.1875 -24.28125 19.609375 -25.40625 C 15.375 -26.125 13.75 -26.671875 13.75 -28.21875 C 13.75 -29.234375 14.40625 -30.3125 17.40625 -30.3125 C 20.5625 -30.3125 25.0625 -29 28.515625 -26.375 L 34.984375 -34.921875 C 30.4375 -38.625 24.578125 -40.484375 18.0625 -40.484375 C 7.109375 -40.484375 1.5 -34.328125 1.5 -27.5625 C 1.5 -17.578125 11.546875 -16.03125 18.125 -14.828125 C 22.0625 -14.109375 23.734375 -13.328125 23.734375 -11.78125 C 23.734375 -10.21875 21.59375 -9.453125 19.3125 -9.453125 C 13.9375 -9.453125 9.453125 -11.71875 6.453125 -14.59375 Z M 0.171875 -5.625 "
  })))), /*#__PURE__*/React.createElement("g", {
    fill: "#1d518c",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(235.362997, 194.406889)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 15.3125 0 L 15.3125 -39.890625 L 3.234375 -39.890625 L 3.234375 0 Z M 15.3125 0 "
  })))), /*#__PURE__*/React.createElement("g", {
    fill: "#1d518c",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(253.899275, 194.406889)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 1.078125 -19.90625 C 1.078125 -7.65625 10.578125 0.71875 22.90625 0.71875 C 35.21875 0.71875 44.734375 -7.65625 44.734375 -19.90625 C 44.734375 -32.171875 35.21875 -40.546875 22.90625 -40.546875 C 10.578125 -40.546875 1.078125 -32.171875 1.078125 -19.90625 Z M 32.46875 -19.90625 C 32.46875 -14.34375 28.703125 -9.921875 22.90625 -9.921875 C 17.109375 -9.921875 13.328125 -14.34375 13.328125 -19.90625 C 13.328125 -25.46875 17.109375 -29.890625 22.90625 -29.890625 C 28.703125 -29.890625 32.46875 -25.46875 32.46875 -19.90625 Z M 32.46875 -19.90625 "
  })))), /*#__PURE__*/React.createElement("g", {
    fill: "#1d518c",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(299.701805, 194.406889)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 41.625 0 L 41.625 -39.890625 L 29.546875 -39.890625 L 29.546875 -19.796875 L 15.671875 -39.890625 L 3.234375 -39.890625 L 3.234375 0 L 15.3125 0 L 15.3125 -21.40625 L 30.015625 0 Z M 41.625 0 "
  })))))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 72,
    cy: 177,
    r: 39,
    fill: "none",
    stroke: "#1d518c",
    strokeWidth: 4
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFusionMark);
export default __webpack_public_path__ + "static/media/fusion-mark.eaba71f4092d9db748714516be893445.svg";
export { ForwardRef as ReactComponent };